import { JSON_FORM } from '#app/constants/forms.ts'
import { extractQuestionIdFromKey } from '#app/features/form/wizard/utils/extractQuestionIdFromKey.ts'
import { type JSONState } from '#types/form/wizard.ts'

interface Params<T> {
	currentQuestionId: string
	id: string
	type: JSONState<T>['type']
	answeredQuestionsStack: JSONState<T>['answeredQuestionsStack']
	currentQuestionTreeId: JSONState<T>['currentQuestionTreeId']
}

export function getUpdateAnsweredQuestionsStack<T>({
	currentQuestionId,
	id,
	type,
	answeredQuestionsStack,
	currentQuestionTreeId,
}: Params<T>) {
	if (type !== JSON_FORM) return

	let updatedAnsweredQuestionsStack = [...answeredQuestionsStack]

	let currentTreeStack = updatedAnsweredQuestionsStack.find(
		stack => stack.id === currentQuestionTreeId,
	)

	if (currentTreeStack) {
		if (!currentTreeStack.answers.includes(currentQuestionId)) {
			currentTreeStack.answers.push(currentQuestionId)
		}
	} else {
		updatedAnsweredQuestionsStack.push({
			id: currentQuestionTreeId,
			answers: [extractQuestionIdFromKey({ key: currentQuestionId, id })],
			currentQuestionId,
		})
	}

	return updatedAnsweredQuestionsStack
}
